<template>
  <side-nav-section
    :section="consts.SIDENAV_PROFILE_SECTION"
    :user="user"
    :active="$route.name.includes('profile') || $route.name === 'activity.log'"
  >
    <side-nav-item :item="consts.SIDENAV_PROFILE_MY_ROUTE(user)" />
    <side-nav-item
      v-if="!user.isValidator && !user.isTemplate"
      :item="consts.SIDENAV_PROFILE_MY_ACTIVITY"
    />
    <a
      v-if="!user.isTemplate"
      href="#"
      @click.prevent="$root.$emit(consts.GLOBAL_EVENT_SHOW_SETTINGS)"
      class="cursor-pointer"
    >
      My settings
    </a>
    <a
      href="https://knowledge.lifetraq.com/knowledge"
      target="_blank"
      class="cursor-pointer"
      >Support</a
    >
    <a
      href="#"
      class="cursor-pointer"
      @click.prevent="$root.$emit(consts.GLOBAL_EVENT_LOGOUT)"
    >
      Logout
    </a>
  </side-nav-section>
</template>

<script>
import {
  SIDENAV_PROFILE_SECTION,
  SIDENAV_PROFILE_MY_ROUTE,
  SIDENAV_PROFILE_MY_ACTIVITY,
} from "Consts/sideNav/profileSection";
import {
  GLOBAL_EVENT_SHOW_SETTINGS,
  GLOBAL_EVENT_LOGOUT,
} from "Consts/globalEvents";
import SideNavSection from "Public/components/SideNav/SideNavSections/SideNavSection";
import SideNavItem from "Public/components/SideNav/SideNavItem";
export default {
  name: "ProfileSection",
  components: { SideNavItem, SideNavSection },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      consts: {
        SIDENAV_PROFILE_SECTION,
        SIDENAV_PROFILE_MY_ROUTE,
        SIDENAV_PROFILE_MY_ACTIVITY,
        GLOBAL_EVENT_SHOW_SETTINGS,
        GLOBAL_EVENT_LOGOUT,
      },
    };
  },
};
</script>

<style scoped></style>
